/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Paste_Attributes_LabelInputs */

const en_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Attributes`)
};

const fr_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller les attributs`)
};

const de_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfügen Attribute`)
};

const it_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla attributi`)
};

const ru_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить атрибуты`)
};

const es_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar atributos`)
};

const zh_cn2_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴属性`)
};

const ja_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性を貼り付け`)
};

const hi_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेषताओं को पेस्ट करें`)
};

const pt_pt2_context_menu_paste_attributes_label = /** @type {(inputs: Context_Menu_Paste_Attributes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atributos de colagem`)
};

/**
* | output |
* | --- |
* | "Paste Attributes" |
*
* @param {Context_Menu_Paste_Attributes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste_attributes_label = /** @type {((inputs?: Context_Menu_Paste_Attributes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Paste_Attributes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_paste_attributes_label(inputs)
	if (locale === "de") return de_context_menu_paste_attributes_label(inputs)
	if (locale === "it") return it_context_menu_paste_attributes_label(inputs)
	if (locale === "ru") return ru_context_menu_paste_attributes_label(inputs)
	if (locale === "es") return es_context_menu_paste_attributes_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_paste_attributes_label(inputs)
	if (locale === "ja") return ja_context_menu_paste_attributes_label(inputs)
	if (locale === "hi") return hi_context_menu_paste_attributes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_paste_attributes_label(inputs)
	return en_context_menu_paste_attributes_label(inputs)
});